import { createFileRoute, Outlet } from '@tanstack/react-router';

// This layout renders the list OR a child (detail) depending on the URL
export const Route = createFileRoute('/_auth/tenants')({
  component: () => <Outlet />,
});
